import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'
import * as variablesBuilder from '../../../../../variables-builder'

import * as generalTab from './general-tab'

@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.layout.widget.Component,
    ds.loader.Component,
    ds.overlay.centered.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    generalTab.Component,
    variablesBuilder.Component,
  ],
  selector: 'atn-mosaic-dev-widget-dialog',
  standalone: true,
  styleUrls: ['./widget.component.scss'],
  templateUrl: './widget.component.html',
})
export class AtnWidgetDialogComponent {
  /** @see {@link AtnMosaicEcService.widgetsCollection} */
  public readonly widgetsEc = ngCore.inject(state.mosaic.dev.widgets.Collection)

  /** @see {@link state.mosaic.dev.widgets.plugins.preview.Plugin} */
  public readonly widgetPreviewPlugin = this.widgetsEc.plugins
    .lookup(state.mosaic.dev.widgets.plugins.preview.Plugin)
    .get()

  /** Title of the widget dialog   */
  public readonly widgetTitleSg = ngCore.computed(
    (
      isNew = this.widgetsEc.plugins.currentEntityPlugin.feature.selectors
        .isCreating()
        .asSignal(),
    ) => {
      if (isNew) {
        return 'New Widget'
      } else {
        // NOTE: not resolving in the arguments list, due to the fact that it
        // might not be needed to be resolved there.
        const widget =
          this.widgetsEc.plugins.currentEntityPlugin.feature.selectors
            .getEditedEntity()
            .asSignal()
        return widget?.name ?? 'Edit Widget'
      }
    },
  )

  // TODO: how to get this from the entity collection?
  /** Loading indicator */
  public readonly loading = ngCore.computed(() => false)

  /** TODO: */
  public runQuery = (source: string) => {
    const id = this.widgetsEc.plugins.currentEntityPlugin.feature.selectors
      .getId()
      .asSignal()
    const widget = this.widgetsEc.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asSignal()
    if (id && widget?.query) {
      this.widgetPreviewPlugin.feature.actions.preview
        .from(`Dialog.${source}`)
        .dispatch({ flexibleIdentifier: { id }, query: widget.query })
    }
  }

  /** TODO: */
  public saveClickHandler = () => {
    this.widgetsEc.plugins.editingPlugin.feature.actions.submit
      .from('Dialog.SaveButton.Clicked')
      .dispatch({
        current: true,
      })
  }

  /** TODO: */
  public cancelClickHandler = () => {
    this.widgetsEc.plugins.editingPlugin.feature.actions.discard
      .from('Dialog.CancelButton.Clicked')
      .dispatch({ current: true })
  }
}
